import RecoverStep from "../recover_step";
import axios from "../../../../axios-instance";
import {createFormData} from "../../../../modules/helpers/form-data-helper";

const TEMPLATE = 'set-ps-password';

export default class SetPsPassword extends RecoverStep {

  constructor() {
    super(TEMPLATE);
  }

  open(data, el, fr, previousStep) {
    fr.render('SetPsPassword');
  }

  postRender(data, el, fr) {
    const passwordInput = document.getElementById("recovery-ps-password");
    const nextButton = document.getElementById("recovery-ps-password-next");
    passwordInput.addEventListener('input', (event) => {
      const password = event.target.value;
      if (password !== '') {
        data.recovery.password = event.target.value;
        nextButton.disabled = false;
      } else {
        nextButton.disabled = true;
      }
    });
  }

  transitionBack(data, el, fr) {
    fr.goTo('rbSetDevice');
  }

  transitionNext(data, el, fr) {
    const checkPasswordData = {
      'machine_id': data.recovery.machineId,
      'password': data.recovery.password
    };

    axios.post(`/ftps_export/verify_ps_password`, createFormData(checkPasswordData)).then(
      response => {
        const passwordInput = document.getElementById("recovery-ps-password");
        if (!response.data.isPasswordCorrect) {
          passwordInput.status='error';
        } else {
          passwordInput.status = '';
          fr.goTo('selectRestorePoint');
        }
      }
    ).catch(() => {
      fr.defaultAJAXErrorHandler()
    });
  }
}
